/**
 * Construit l'URL d'une sous-catégorie de façon entièrement dynamique.
 *
 * Chaque catégorie parente (Bureau/Chaise/Table/Rangement) est associée à
 * la ressource API correspondante ; la sous-catégorie est ensuite passée
 * telle quelle dans l'URL et lue côté page via `GET /:resource/type/:type`.
 * Ainsi, ajouter une nouvelle sous-catégorie dans l'admin (ex: "Bureau la")
 * la rend immédiatement accessible, sans toucher au routage.
 */
const RESOURCE_BY_CATEGORY = {
  Bureau: 'bureau',
  Chaise: 'chaise',
  Table: 'table',
  Rangement: 'armoire',
};

// "Comptoir d'accueil" (catégorie "Desk") n'a pas de champ `type` sur son
// modèle produit — sa page reste une simple liste statique, pas de filtre
// dynamique par sous-catégorie possible.
const STATIC_FALLBACK_ROUTES = {
  Desk: "/COMPTOIR-D'ACCUEIL",
};

export const getSubcategoryPath = (subCategoryName, parentCategoryName) => {
  const resource = RESOURCE_BY_CATEGORY[parentCategoryName];
  if (resource) {
    return `/produits/${resource}/${encodeURIComponent(subCategoryName)}`;
  }
  return STATIC_FALLBACK_ROUTES[parentCategoryName] || '/';
};
